<ng-template #newActivityModal>
    <div class="page-modal-section">
        <div class="page-modal-heading-section">
            <span>Add New Activity</span>
            <span class="page-modal-close-icon" (click)="closeNewActivityModal()">&times;</span>
        </div>
        <div class="page-modal-content-section">
            <div class="page-modal-input-section">
                <p class="page-modal-input-label">Activity *</p>
                <mat-select class="page-modal-input" [(ngModel)]="activity_data.communication_type">
                    <mat-option [value]="''">Select Activity</mat-option>
                    <mat-option *ngFor="let communication_type of communication_type_list" [value]="communication_type.id">{{communication_type.name}}</mat-option>
                </mat-select>
                <p class="page-modal-input-error" *ngIf="new_activity_data_errors.communication_type">Activity is Required.</p>
            </div>
            <div class="page-modal-input-section">
                <p class="page-modal-input-label">Description *</p>
                <textarea class="page-modal-input" [(ngModel)]="activity_data.name"></textarea>
                <p class="page-modal-input-error" *ngIf="new_activity_data_errors.name">Description is Required.</p>
            </div>
            <div class="page-modal-input-section">
                <p class="page-modal-input-label">Due Date *</p>
                <input
                    type="text"
                    class="page-modal-input"
                    bsDatepicker
                    placement="left"
                    [(ngModel)]="activity_data.scheduled_date"
                    [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                />
                <p class="page-modal-input-error" *ngIf="new_activity_data_errors.scheduled_date">Due Date is Required.</p>
            </div>
        </div>
        <div class="page-modal-footer-section">
            <button class="page-modal-primary-button" *ngIf="!new_activiity_data_loader" (click)="saveNewActivityData()">Save</button>
            <button class="page-modal-primary-button" *ngIf="new_activiity_data_loader">Saving . . .</button>
            <button class="page-modal-secondary-button" (click)="closeNewActivityModal()">Cancel</button>
        </div>
    </div>
</ng-template>